import React from 'react'
import { InputGroup } from '@blueprintjs/core'

const AppScopeInput = props => {
   return (
      <InputGroup
         large
         intent={props.disable ? 'danger' : ''}
         onChange={props.inputChangeHandler}
         value={props.value}
         placeholder="Type your application scope"
      />
   )
}

export default AppScopeInput
